export default "__VITE_ASSET__CFBhGSsC__"